import { useState } from 'react';

import "./resources.css";
import { Divider } from "@mui/material";
import { Button } from "@mui/material";
import TextField from "@mui/material/TextField";
import ResourcesList from './ResourcesList';
import { useGetResourcesQuery, useCreateResourceMutation, useUpdateResourceMutation, useDeleteResourceMutation } from "../../../../services/resourcesApi";
import { useDispatch } from 'react-redux';
import { setResources, selectAllResources, updateResource, deleteResource as deleteResourceStore } from "../../../../store/slices/resources";
import { useSelector } from 'react-redux';

import Radio from '@mui/material/Radio';
import RadioGroup from '@mui/material/RadioGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormControl from '@mui/material/FormControl';
import FormLabel from '@mui/material/FormLabel';
import { getFileNameFromEHLink } from "../../../../utils";

import { useNotification } from '../../../../context/NotificationContext';

import FileUploadOutlinedIcon from '@mui/icons-material/FileUploadOutlined';
import ResourceHeaderPanel from './ResourceHeaderPanel';
import ResourceHeaderDropdown from './components/ResourceHeaderDropdown';



const NewResourceForm = ({ onSuccess, isCreating }) => { //A: onSoucces is called if all validations pass

  const [userInputSelection, setUserInputSelection] = useState("link");
  //A: in a new resource the user can set a external link or upload a file
  //so we need to keep track of the user choice, link by default

  const [newResource, setNewResource] = useState({
    title: "",
    description: "",
    url: "",
    resourceHeaderId: "",
  });

  const [formErrors, setFormErrors] = useState({
    title: "",
    description: "",
    url: "",
  })

  const handleRadioButtonChange = (event) => {
    setUserInputSelection(event.target.value);
  };

  function onChangeInputHandler(e) {
    setFormErrors({ ...formErrors, [e.target.name]: "" });
    setNewResource({ ...newResource, [e.target.name]: e.target.value });
    if (e.target.name == "url") {
      setNewResource(prev => ({ ...prev, file: null }))
    }
    //A: if the user is changing the url input, we need to clear the file input
  }

  function handleSaveClick() {
    console.log("new resource in form: " + JSON.stringify(newResource));

    //A: if validation passes, call onSuccess
    if (validateForm()) {
      let aux = { ...newResource };
      setNewResource({ title: "", description: "", url: "", file: null, resourceHeaderId: ""});
      onSuccess(aux);
    }
  }

  function validateForm() {
    let isValid = true;
    let auxFormErrors = { ...formErrors };
    if (newResource.title === "") {
      auxFormErrors.title = "Title is required";
      isValid = false;
    }

    if (newResource.resourceHeaderId === "") {
      auxFormErrors.resourceHeaderId = "Resource Header is required";
      isValid = false;
    }

    //A: description is not required

    // if(newResource.description === ""){
    //   auxFormErrors.description = "Description is required";
    //   isValid = false;
    // }

    if (newResource.url === "" && !newResource.file && !newResource.url > 0 ) {
      auxFormErrors.url = "Link or File are required";
      isValid = false;
    }

    if (newResource.url.length > 200) {
      auxFormErrors.url = "Link is too long";
      isValid = false;
    }

    setFormErrors(auxFormErrors);

    return isValid;
  }

  function LinkOrFileSelection() {
    return (
      <FormControl style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', whiteSpace: 'nowrap' }} >
        <FormLabel
          id="demo-controlled-radio-buttons-group"
          style={{ fontWeight: '600', color: 'var(--darkbrown)', margin: '0 2em 0 0' }}
        >
          Resource Type
        </FormLabel>
        <RadioGroup
          aria-labelledby="demo-controlled-radio-buttons-group"
          name="controlled-radio-buttons-group"
          value={userInputSelection}
          onChange={handleRadioButtonChange}
          row
          style={{ flexWrap: 'nowrap', margin: '0 2em 0 0' }}
        >
          <FormControlLabel value="link" control={<Radio />} label="Link" />
          <FormControlLabel value="file" control={<Radio />} label="File" />
        </RadioGroup>
      </FormControl>
    )
  }

  const MAX_FILE_SIZE_MB = 200; // max file size in MB
  const handleFileChange = (e) => {
    formErrors.url= "";
    if (e.target.files) {
      const fileSizeInBytes = e.target.files[0].size;
      const fileSizeInMB = fileSizeInBytes / (1024 * 1024);

      if (fileSizeInMB > MAX_FILE_SIZE_MB) {
        e.target.value = null;
        alert(`The selected file is too big. The maximum allowed size is ${MAX_FILE_SIZE_MB} MB`);
      } else {
        setNewResource(prev => ({ ...prev, url: "", file: e.target.files[0] }))
      }
    }
  };


  return (
    <div>
      <h4 style={{ margin: "0 0 1em 0", fontWeight: '600' }} >Create New Resource</h4>

      <div className="create-resources-inputs">
        <div style={{ width: "100%", margin: '0 0 1em 0' }}>
          <div className="create-resouces-text" >
            <label for="title" style={{ width: "100px", margin: '1.25em 0 0 0' }}>
              Title:
            </label>

            <TextField
              fullWidth={true}
              multiline={true}
              error={formErrors.title != ""}
              helperText={formErrors.title}
              sx={{ width: "100%" }}
              value={newResource.title}
              name="title"
              onChange={onChangeInputHandler}
            />
          </div>

          <div className="create-resouces-text">
            <label
              for="message"
              style={{ width: "100px", margin: "1.25em 0 0 0" }}
            >
              Description:{" "}
            </label>

            <TextField
              error={formErrors.description != ""} helperText={formErrors.description}
              multiline={true}
              rows={3}
              name="description"
              variant="outlined"
              id="resource-description-input"
              sx={{ width: "100%" }}
              value={newResource.description}
              onChange={onChangeInputHandler}
            />
          </div>

          <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-start' }} >

            <LinkOrFileSelection />

            {userInputSelection === "link" ?
              <div style={{ width:'100%', padding:'0 0 0 5em'}} >
                <label for="title" />
                <TextField
                  fullWidth={true}
                  multiline={true}
                  error={formErrors.url != ""}
                  helperText={formErrors.url}
                  variant="outlined"
                  value={newResource.url}
                  name="url"
                  onChange={onChangeInputHandler}
                />
              </div>
            :
              <div style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                justifyContent: 'flex-start',
              }}>

                {/* new resource form, upload file */}

                <Button  sx={{margin: "0 0.5em 0 0"}} variant="outlined" component="label">
                  <FileUploadOutlinedIcon/>
                  Upload
                  <input hidden type="file" onChange={handleFileChange}/>
                </Button>  
                {/* Upload file button */}

                {<p> {(newResource.file?.name || "")}</p> } 
                {/* show fileName */}

                {formErrors.url != "" && <p style={{ color: 'red', margin: '0 0 0 1em' }}>{formErrors.url}</p>}
                {/* errors for file upload */}

              </div>
              // we do not move this to another component because the file input lose the file when we do that
            }

          </div>
          <ResourceHeaderDropdown error={formErrors.resourceHeaderId} value={newResource.resourceHeaderId} 
          onChangeHandler={(value) =>{
            setFormErrors({ ...formErrors, resourceHeaderId: "" });
            setNewResource({ ...newResource, resourceHeaderId: value });
          }} 
          />

        </div>


        <div className="create-resource-submit">
          <Button
            variant="contained"
            className="button"
            style={{ margin: "0 0 1em 0" }}
            onClick={handleSaveClick}
            disabled={isCreating}
          >
            Create
          </Button>
        </div>
      </div>
    </div>
  )

}

const ResourcesPanel = () => {

  const { showNotification } = useNotification();
  
  const dispatch = useDispatch();
  const resources = useSelector(selectAllResources);
  const { data: resourcesFromApi, isLoading, isFetching, isErrorLoadingResources, error } = useGetResourcesQuery();
  const [createResource] = useCreateResourceMutation();
  const [updateResourceApi] = useUpdateResourceMutation();
  const [deleteResourceApi] = useDeleteResourceMutation();

  const [isCreating, setIsCreating] = useState(false);

  if (isErrorLoadingResources) {
    console.log("error loading resources : " + error + " , " + JSON.stringify(error));
    //A: check if the error is a 401, if not send raygun error
  }

  if (resources == null && resourcesFromApi && resourcesFromApi.length > 0 && !isErrorLoadingResources) {
    console.log("RESOURCES RES: ", resourcesFromApi)
    dispatch(setResources(resourcesFromApi))
  }

  async function createNewRosource(newResource) {
    try {
      console.log("new resource: " + JSON.stringify(newResource))
      setIsCreating(true);

      const formData = new FormData();
      formData.append("title", newResource.title);
      formData.append("description", newResource.description);
      if (newResource.url) {
        formData.append("url", newResource.url);
      } else {
        formData.append("file", newResource.file);
      }

      if(newResource.resourceHeaderId){
        formData.append("resourceHeaderId", newResource.resourceHeaderId);
      }

      let res = await createResource(formData).unwrap();
      setIsCreating(false);
      //A: todo add notificacion for success
      console.log("new resource created: " + JSON.stringify(res));
      if (res.id) {
        showNotification('Resource created successfully', 'success');
        dispatch(setResources([...resources, res]));
      }
    } catch (error) {
      console.log("error: " + error + " , stringify: " + JSON.stringify(error));
      setIsCreating(false);
      if (error && error.status == 401) return; //A: if unauthorized error, do nothing
      showNotification('Error creating resource', 'error');
      throw new Error("Error creating resources, body: " + JSON.stringify(newResource) + " error stringify: " + JSON.stringify(error) + " , error: " + error);
    }
  }

  async function editResource(editedResource) {
    try {
      let res = await updateResourceApi(editedResource).unwrap();
      console.log("edited resource api res: " + JSON.stringify(res));
      if (res.id) {
        dispatch(updateResource(res));
      }
      return true;
    } catch (error) {
      if (error && error.status == 401) return false; //A: if unauthorized error, do nothing
      showNotification('Error editing resource', 'error');
      throw new Error("Error editing resource, body: " + JSON.stringify(editedResource) + " error stringify: " + JSON.stringify(error) + " , error: " + error);
    }
  }

  async function deleteResource(id) {
    try {
      let res = await deleteResourceApi(id).unwrap();
      console.log("deleted resource api res: " + JSON.stringify(res));
      if (res.id) {
        showNotification('Resource Deleted Successfully', 'success');
        dispatch(deleteResourceStore(res.id));
      }
      return true;
    } catch (error) {
      console.log("error: " + error + " , " + JSON.stringify(error));
      if (error && error.status == 401) return; //A: if unauthorized error, do nothing
      throw new Error("Error deleting resource, resourceId: " + id + " error stringify: " + JSON.stringify(error) + " , error: " + error);
    }
  }

  return (
    <div className="resources-container">
      <h4 style={{ margin: "0 0 1em 0" }}>RESOURCES</h4>
      <Divider style={{ margin: "0 0 1em 0" }} />


      <ResourceHeaderPanel />

      <Divider style={{ margin: "0 0 1em 0" }} />

      <NewResourceForm onSuccess={createNewRosource} isCreating={isCreating} />

      <Divider style={{ margin: "0 0 1em 0" }} />
      {/* new resource Form */}

      <ResourcesList resources={resources} onEditHandler={editResource} onDeleteHandler={deleteResource} />
      {/* resource List */}

    </div>
  );
};

export default ResourcesPanel;
